import { render, staticRenderFns } from "./pn-only.vue?vue&type=template&id=53880bde"
import script from "./pn-only.vue?vue&type=script&lang=js"
export * from "./pn-only.vue?vue&type=script&lang=js"
import style0 from "./pn-only.vue?vue&type=style&index=0&id=53880bde&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports